import type { AnniversaryTileEvent } from "./tile-birthdays-anniversaries";

/**
 * Generates anniversary dates for the given year, as well as the previous and next year,
 * based on the employee's first contract start date (month and day).
 */
export function getAnniversaryDatesForYears(contractStart: string, year: number) {
    const { month, day } = parseDate(contractStart);

    const currentYearAnniversary = new Temporal.PlainDateTime(year, month, day);
    const nextYearAnniversary = new Temporal.PlainDateTime(year + 1, month, day);
    const prevYearAnniversary = new Temporal.PlainDateTime(year - 1, month, day);

    return {
        currentYearAnniversary,
        nextYearAnniversary,
        prevYearAnniversary,
    };
}

export function getAnniversaryLabel(event: AnniversaryTileEvent): string {
    switch (event.type) {
        case "birthday":
            return `${getAnniversaryYears(event.data.birthday!, event.date)} Jahre`;
        case "anniversary": {
            const years = getAnniversaryYears(event.data.firstContract!.start, event.date);
            if (years === 1) {
                return "1 Dienstjahr";
            }
            return `${years} Dienstjahre`;
        }
    }
}

function getAnniversaryYears(employeeDate: string, anniversaryDate: Temporal.PlainDateTime): number {
    const { year } = parseDate(employeeDate);
    return anniversaryDate.year - year;
}

function parseDate(date: string) {
    const match = date.match(/^(\d{4})-(\d{2})-(\d{2})$/);

    if (!match) {
        throw new Error(`Invalid date: ${date}`);
    }

    return {
        year: Number(match[1]),
        month: Number(match[2]),
        day: Number(match[3]),
    };
}
